import type { UseListProps } from '@ztechapps/common.hook'
import { StorageType, useList, useUserTimeZone } from '@ztechapps/common.hook'
import { taskListFragment } from './graphql'
import type { SetOptional } from 'type-fest'
import { gql } from '@apollo/client'

export const taskListQuery = gql`
  query allTask($filter: JSON!, $options: JSON) {
    allTask(filter: $filter, options: $options) {
      ...taskListFragment
    }
    allTaskMeta(filter: $filter) {
      count
    }
  }
  ${taskListFragment}
`

export const useTaskList = ({ listActionOptions = {}, query, ...props }: SetOptional<UseListProps, 'query'>) => {
  const timeZone = useUserTimeZone()

  query = query ?? taskListQuery

  const finalDefaultListActions = {
    ...listActionOptions,
    storageType: StorageType.localStorage,
    timeZone,
  }

  return useList({
    query,
    ...props,
    limit: 100,
    sort: { createdAt: -1 },
    listActionOptions: finalDefaultListActions,
  })
}
